import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import {
  PARTNER_LEAD_STATUS_LABELS,
  getCategoryLabel,
  partnerLeadStatusBadgeClass,
} from "../../../constants/automapPartnershipConstants";
import { fetchPartnerLeads } from "../../../services/automapPartnershipApi";
import { AdminPartnerDetailNav, usePartnerIdParam } from "./AdminPartnersShared";

export default function AdminPartnerLeadsPage() {
  const partnerId = usePartnerIdParam();
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPartnerLeads({ partnerId })
      .then((d) => setLeads(d.leads || []))
      .finally(() => setLoading(false));
  }, [partnerId]);

  return (
    <AdminPageLayout>
      <AdminPageHeader eyebrow="AutoMapa · Aliado" title="Leads del aliado" />
      <AdminAutomotiveNav active="partners" />
      <AdminPartnerDetailNav partnerId={partnerId} active="leads" />
      <main className="admin-console__main wrap">
        {loading ? <p>Cargando…</p> : (
          <div className="import-table-wrap">
            <table className="import-table">
              <thead><tr><th>Fecha</th><th>Comprador</th><th>Ciudad</th><th>Vehículo</th><th>Estado</th><th>Origen</th><th></th></tr></thead>
              <tbody>
                {leads.map((l) => (
                  <tr key={l.id}>
                    <td>{new Date(l.createdAt).toLocaleDateString("es-CO")}</td>
                    <td>{l.buyerName}</td>
                    <td>{l.buyerCity || "—"}</td>
                    <td>{l.vehicleLabel}</td>
                    <td><span className={partnerLeadStatusBadgeClass(l.status)}>{PARTNER_LEAD_STATUS_LABELS[l.status]}</span></td>
                    <td>{l.sourcePage || "—"}</td>
                    <td><Link to={`/admin/partners/leads/${l.id}`}>Abrir</Link></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </main>
    </AdminPageLayout>
  );
}

export function AdminAllPartnerLeadsPage() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [unassigned, setUnassigned] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetchPartnerLeads({ unassigned: unassigned ? "true" : undefined })
      .then((d) => setLeads(d.leads || []))
      .finally(() => setLoading(false));
  }, [unassigned]);

  return (
    <AdminPageLayout>
      <AdminPageHeader eyebrow="AutoMapa · Aliados" title="Leads de aliados" />
      <AdminAutomotiveNav active="partners" />
      <main className="admin-console__main wrap">
        <label><input type="checkbox" checked={unassigned} onChange={(e) => setUnassigned(e.target.checked)} /> Solo sin asignar</label>
        {loading ? <p>Cargando…</p> : (
          <div className="import-table-wrap">
            <table className="import-table">
              <thead><tr><th>Fecha</th><th>Categoría</th><th>Comprador</th><th>Aliado</th><th>Estado</th><th>Origen</th><th></th></tr></thead>
              <tbody>
                {leads.map((l) => (
                  <tr key={l.id}>
                    <td>{new Date(l.createdAt).toLocaleDateString("es-CO")}</td>
                    <td>{getCategoryLabel(l.category)}</td>
                    <td>{l.buyerName}</td>
                    <td>{l.partnerName}</td>
                    <td>{PARTNER_LEAD_STATUS_LABELS[l.status]}</td>
                    <td>{l.sourcePage || "—"}</td>
                    <td><Link to={`/admin/partners/leads/${l.id}`}>Abrir</Link></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </main>
    </AdminPageLayout>
  );
}
